import { render } from "./2022-11-16-Framework Selection.md?vue&type=template&id=7ca0e857"
const script = {}
script.render = render

export default script